import { SelectControl } from './SelectControl';

function classNames(...parts) {
  return parts.filter(Boolean).join(' ');
}

export function FormField({
  label,
  name,
  value,
  onChange,
  required,
  type = 'text',
  placeholder = '',
  options,
  disabled = false,
  readOnly = false,
  onBlur,
  busy = false,
  ...rest
}) {
  const isEmpty = !value || (typeof value === 'string' && value.trim() === '');
  const inputClassName = classNames(
    'field-input',
    (disabled || readOnly) && 'is-disabled',
    isEmpty && required && 'is-incomplete',
    busy && 'is-busy'
  );

  const control = Array.isArray(options) ? (
    <SelectControl
      id={name}
      name={name}
      value={value}
      onChange={onChange}
      options={options}
      placeholder={placeholder || 'Select an option'}
      disabled={disabled}
      className={inputClassName}
    />
  ) : (
    <input
      id={name}
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      disabled={disabled}
      readOnly={readOnly}
      className={inputClassName}
      {...rest}
    />
  );

  return (
    <div className="field">
      <label className="field-label" htmlFor={name}>
        {label}
        {required && <span className="required-mark">*</span>}
      </label>
      <div className="field-control">
        {control}
        {busy && <div className="spinner spinner-sm" aria-hidden="true" />}
      </div>
    </div>
  );
}
